import { useContext, useMemo } from "react";
import { AuthContext } from "../context/AuthContext";
import ErrorBoundary from "../components/ErrorBoundary";
import Eventos from "../components/dashboard/Eventos";
import Misioneros from "../components/dashboard/Misioneros";
import Cumpleanios from "../components/dashboard/Cumpleanios";
import EstadisticasTesoreria from "../components/dashboard/EstadisticasTesoreria";
import EstadisticasClubResumen from "../components/dashboard/EstadisticasClubResumen";
import EstadisticasDominicalResumen from "../components/dashboard/EstadisticasDominicalResumen";

// Los módulos llegan como un árbol (módulo -> submodulos), así que hay que
// buscar recursivamente en vez de solo revisar el primer nivel.
const ID_MODULO_TESORERIA_GENERAL = 15;
const ID_MODULO_TESORERIA_MISIONES = 18;
const ID_MODULO_VISITACION_CLUB = 7;
const ID_MODULO_ESCUELA_DOMINICAL = 16;

function tieneModulo(modulos, idModulo) {
  return modulos.some(
    (m) => m.id_modulo === idModulo || (m.submodulos?.length && tieneModulo(m.submodulos, idModulo))
  );
}

export default function DashboardHome() {
  const { modulos } = useContext(AuthContext);

  const { tieneGeneral, tieneMisiones, tieneClub, tieneDominical } = useMemo(
    () => ({
      tieneGeneral: tieneModulo(modulos, ID_MODULO_TESORERIA_GENERAL),
      tieneMisiones: tieneModulo(modulos, ID_MODULO_TESORERIA_MISIONES),
      tieneClub: tieneModulo(modulos, ID_MODULO_VISITACION_CLUB),
      tieneDominical: tieneModulo(modulos, ID_MODULO_ESCUELA_DOMINICAL),
    }),
    [modulos]
  );

  const tieneTesoreria = tieneGeneral || tieneMisiones;
  const columnasTesoreria = tieneGeneral && tieneMisiones ? "md:grid-cols-2" : "md:grid-cols-1";
  const tieneAsistencia = tieneClub || tieneDominical;
  const columnasAsistencia = tieneClub && tieneDominical ? "md:grid-cols-2" : "md:grid-cols-1";

  return (
    <div className="max-w-7xl mx-auto space-y-6">

      <div>
        <h1 className="text-xl font-bold text-slate-800">Panel principal</h1>
        <p className="text-sm text-slate-500">Resumen general de la iglesia</p>
      </div>

      {/* EVENTOS + MISIONEROS */}
      <div className="grid md:grid-cols-2 gap-6">
        <ErrorBoundary titulo="los próximos eventos"><Eventos /></ErrorBoundary>
        <ErrorBoundary titulo="los misioneros"><Misioneros /></ErrorBoundary>
      </div>

      {/* ESTADÍSTICAS SEGÚN LOS MÓDULOS DEL USUARIO (independientes entre sí) */}
      {tieneTesoreria && (
        <div className={`grid ${columnasTesoreria} gap-6`}>
          {tieneGeneral && (
            <ErrorBoundary titulo="Tesorería General">
              <EstadisticasTesoreria tipo={1} titulo="Tesorería General" />
            </ErrorBoundary>
          )}
          {tieneMisiones && (
            <ErrorBoundary titulo="Tesorería Misiones">
              <EstadisticasTesoreria tipo={2} titulo="Tesorería Misiones" />
            </ErrorBoundary>
          )}
        </div>
      )}

      {tieneAsistencia && (
        <div className={`grid ${columnasAsistencia} gap-6`}>
          {tieneClub && <ErrorBoundary titulo="la asistencia a club"><EstadisticasClubResumen /></ErrorBoundary>}
          {tieneDominical && <ErrorBoundary titulo="la asistencia a escuela dominical"><EstadisticasDominicalResumen /></ErrorBoundary>}
        </div>
      )}

      {/* CUMPLEAÑOS */}
      <ErrorBoundary titulo="los próximos cumpleaños"><Cumpleanios /></ErrorBoundary>

    </div>
  );
}
